
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 16.5H9a.5.5 0 01-.5-.5V.5A.5.5 0 019 0h6a.5.5 0 01.5.5V16a.5.5 0 01-.5.5zm-5.5-1h5V1h-5zM15 24H9a.5.5 0 01-.5-.5v-5A.5.5 0 019 18h6a.5.5 0 01.5.5v5a.5.5 0 01-.5.5zm-5.5-1h5v-4h-5zm14 1h-6a.5.5 0 01-.5-.5V8a.5.5 0 01.5-.5h6a.5.5 0 01.5.5v15.5a.5.5 0 01-.5.5zM18 23h5V8.5h-5zm5.5-17h-6a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h6a.5.5 0 01.5.5v5a.5.5 0 01-.5.5zM18 5h5V1h-5zM6.5 24h-6a.5.5 0 01-.5-.5V8a.5.5 0 01.5-.5h6A.5.5 0 017 8v15.5a.5.5 0 01-.5.5zM1 23h5V8.5H1zM6.5 6h-6a.5.5 0 01-.5-.5v-5A.5.5 0 01.5 0h6a.5.5 0 01.5.5v5a.5.5 0 01-.5.5zM1 5h5V1H1z"}})])
          )
        }
      }
    